import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

/** Opens Razorpay Standard Checkout for a catalogue product and verifies the signature server-side. */
export async function payWithRazorpay({ product, user, projectId, amountOverride, onSuccess }) {
  if (!window.Razorpay) {
    toast.error("Payment library failed to load. Check your connection and retry.");
    return;
  }

  let order;
  try {
    const { data } = await api.post("/create-order", {
      product_id: product.id,
      project_id: projectId || null,
      amount: amountOverride || null,
    });
    order = data;
  } catch (e) {
    toast.error(apiError(e.response?.data?.detail));
    return;
  }

  const rzp = new window.Razorpay({
    key: order.key_id || process.env.REACT_APP_RAZORPAY_KEY_ID,
    amount: order.amount,
    currency: order.currency,
    order_id: order.order_id,
    name: "Plan-Sarthi",
    description: `${order.product_label} — Plan Smarter. Build Stronger. Deliver on Time.`,
    image: "/favicon.svg",
    theme: { color: "#0B2038" },
    prefill: { name: user?.name || "", email: user?.email || "" },
    notes: { product: product.id },
    modal: {
      ondismiss: () => toast.info("Payment cancelled — nothing has been charged."),
    },
    handler: async (res) => {
      try {
        const { data } = await api.post("/verify-payment", {
          razorpay_order_id: res.razorpay_order_id,
          razorpay_payment_id: res.razorpay_payment_id,
          razorpay_signature: res.razorpay_signature,
        });
        toast.success(
          data.already_processed
            ? `${data.product} was already activated`
            : `Payment verified — ${data.product} activated`
        );
        onSuccess?.(data);
      } catch (e) {
        toast.error(apiError(e.response?.data?.detail) || "Payment could not be verified");
      }
    },
  });

  rzp.on("payment.failed", (res) => {
    toast.error(res?.error?.description || "Payment failed. No amount has been captured.");
  });

  rzp.open();
}
